import React from "react";

function CheckBoxInput({
  label,
  id,
  name,
  disabled = false,
  required,
  handleClick,
  labelClick,
  errorMessage,
  checked = false,
  value,
  handleBlur,
  style,
  title,
}) {
  return (
    <div
      className={`form-check mt-2 ${
        disabled ? "cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      <label
        className="form-check-label fs-5 form-label-custom-visible"
        htmlFor={id}
        style={{ color: "#111827", fontWeight: "400" }}
        onClick={labelClick}
      >
        {label}{" "}
        {required && (
          <span className="text-danger" htmlFor={id}>
            *
          </span>
        )}
      </label>
      <input
        // className="form-check-input cursor-pointer"
        className={`form-check-input cursor-pointer ${
          disabled && checked === false ? "bg-gray-500 cursor-not-allowed" : ""
        }`}
        type="checkbox"
        value={value}
        id={id}
        style={style}
        disabled={disabled}
        name={name}
        onChange={handleClick}
        checked={checked}
        onBlur={handleBlur}
      />
      {title && (
        <span
          style={{
            marginLeft: "10px",
            position: "relative",
            top: "2px",
          }}
        >
          <i
            title={title}
            className="fs-4 fa fa-info-circle"
            aria-hidden="true"
          ></i>
        </span>
      )}
      {errorMessage &&
        errorMessage[name] &&
        Object?.keys(errorMessage).length > 0 && (
          <div className="text-danger fw-700 fs-6 mt-1">
            {errorMessage && errorMessage[name] && errorMessage[name]}
          </div>
        )}
    </div>
  );
}

export default CheckBoxInput;
